module.exports = __webpack_public_path__ + "img/purse (3).37389210.png";